
import React, { useEffect, useState } from 'react';
import { Input } from "antd";
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search_icon.gov.svg';
import '../../../../../../styles/pages/_searchBarComponent.scss';



const SearchComponent = (props) => {
    const prefix = <SearchIcon />;
    const { Search } = Input;
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(()=>{
        if(searchTerm.length>0) {
            const filteredUsers = props.allUsers.filter( user =>
                user.id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.email?.toLowerCase().includes(searchTerm.toLowerCase())
            )
            props.setDisplayedUsers(filteredUsers);
            props.setChecked(false);
            props.setSelectedUsers([]);
        } else {
            props.setDisplayedUsers(props.allUsers);
            props.setChecked(false);
            props.setSelectedUsers([]);
        }
    },[searchTerm])

    return (
        <div>
            <Search
                onChange={event => setSearchTerm(event.target.value) && props.setCurrentPage(1)}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                placeholder="Search with User ID, First Name, Last Name, Email"
                enterButton
            />
        </div>
    );
};

export default SearchComponent;
